<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择库存"
      width="1100px"
      top="5vh">
    <vm-table ref="vmTable" :filter.sync="filter" module="basic" url="stockDetails">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="库位编号：">
            <el-input v-model.trim="filter.code" placeholder="请输入库位编号" clearable/>
          </vm-search>
          <vm-search label="库位名称：">
            <el-input v-model.trim="filter.locationName" placeholder="请输入库位名称" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialSn" align="left" label="序列号" width="150"/>
      <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
      <el-table-column prop="materialName" min-width="380" align="left" label="物料名称"/>
      <el-table-column prop="code" align="left" label="库位编号" width="120"/>
      <el-table-column prop="locationName" align="left" label="库位名称" min-width="140"/>
      <el-table-column prop="quantity" align="center" label="库存数量" width="80"/>
      <el-table-column prop="materialHeight" align="center" label="高度" width="80"/>
      <el-table-column prop="materialWidth" align="center" label="宽度" width="80"/>
      <el-table-column prop="unitName" align="center" label="单位" width="80"/>
      <el-table-column prop="note" align="left" show-overflow-tooltip label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="80px"
          prop="action">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onSelect(scope.row)"> 选择 </el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "InventorySelect",
    components: { VmTable, VmSearch },
    data() {
      return {
        searchShow: false,
        dialogVisible: false,
        filter: {},
      };
    },
    methods: {
      open(row) {
        this.filter.ignoreLocationId = row.locationId;
        this.filter.materialNo = row.materialNo;
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },

      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>
